/** Все допустимые экраны виджета */
export const SCREENS = {
  LANGUAGE:   'language',
  WELCOME:    'welcome',
  SCENARIO:   'scenario',
  INDUSTRY:   'industry',
  GOAL:       'goal',
  GEOGRAPHY:  'geography',
  FORMAT:     'format',
  RESULTS:      'results',
  EVENT_DETAIL: 'eventDetail',
  CATCHUP:      'catchup',
  NAME:       'name',
  COMPANY:    'company',
  CONTACTS:   'contacts',
  CHANNEL:    'channel',
  TELEGRAM:   'telegram',
  EMAIL_CONFIRM: 'emailConfirm',
  EMAIL_EDIT:    'emailEdit',
  EMAIL_INQUIRY: 'emailInquiry',
  MANAGER:    'manager',
  OFFLINE:    'offline',
  LEAD_ERROR: 'leadError',
  GUIDE:      'guide',
  FAQ:        'faq',
  FAQ_UNSURE: 'faqUnsure',
  LIVE_CHAT:  'liveChat',
};

/** Действия диспетчера состояния */
export const ACTIONS = {
  SET_SCREEN:       'SET_SCREEN',
  GO_BACK:          'GO_BACK',
  GO_MENU:          'GO_MENU',
  TOGGLE_OPEN:      'TOGGLE_OPEN',
  SET_OPEN:         'SET_OPEN',
  SET_LANGUAGE:     'SET_LANGUAGE',
  SET_LEAD_FIELD:   'SET_LEAD_FIELD',
  SET_LEAD_DATA:    'SET_LEAD_DATA',
  SET_USER_FIELD:   'SET_USER_FIELD',
  SET_INTERESTS:       'SET_INTERESTS',
  SET_SELECTED_EVENT:  'SET_SELECTED_EVENT',
  RESET:               'RESET',
};

/** Поддерживаемые языки */
export const LANGUAGES = {
  EN: 'en',
  AR: 'ar',
};

/** RTL-языки */
export const RTL_LANGUAGES = new Set([LANGUAGES.AR]);

/** Ключи localStorage */
export const STORAGE_KEYS = {
  LANGUAGE: 'ibc_language',
  USER_ID:  'ibc_user_id',
};

/** Варианты отраслей для экрана 3 */
export const INDUSTRY_OPTIONS = [
  { value: 'energy',  labelKey: 'industry.energy'  },
  { value: 'finance', labelKey: 'industry.finance' },
  { value: 'tech',    labelKey: 'industry.technology' },
  { value: 'other',   labelKey: 'industry.other'   },
];

/** Варианты целей для экрана 4 */
export const GOAL_OPTIONS = [
  { value: 'networking', labelKey: 'goal.networking'  },
  { value: 'market',     labelKey: 'goal.marketEntry' },
  { value: 'investment', labelKey: 'goal.investment'  },
  { value: 'pr',         labelKey: 'goal.pr'          },
];

/** Варианты географий для экрана 5 */
export const GEO_OPTIONS = [
  { value: 'russia',     labelKey: 'geography.russia'    },
  { value: 'asia',       labelKey: 'geography.asia'      },
  { value: 'middleeast', labelKey: 'geography.middleEast'},
  { value: 'africa',     labelKey: 'geography.africa' },
];

/** Варианты форматов для экрана 6 */
export const FORMAT_OPTIONS = [
  { value: 'participant', labelKey: 'format.participant' },
  { value: 'exhibitor',   labelKey: 'format.exhibitor'   },
  { value: 'delegation',  labelKey: 'format.delegation'  },
  { value: 'notsure',     labelKey: 'format.notSure'     },
];

/** Длительность анимации менеджера перед переходом на оффлайн (мс) */
export const MANAGER_TIMEOUT_MS = 4000;
